const ScrollLink = ((($) => {
  let scroller;
  let hash;
  let target;

  function init() {
    scroller = $('.scroll-to');

    _attachEvents();
  }

  function _attachEvents() {
    $( document ).ready(function() {
      $(this);
      hash= window.location.hash;
      if ( hash == '' || hash == '#' || hash == undefined ) return false;
      target = $(hash);
      target = target.length ? target : $('[name=' + hash.slice(1) +']');
      if (target.length) {
        $('html,body').stop().animate({
          scrollTop: target.offset().top - 125 //offsets for fixed header
        }, 'linear');
      }
    } );
    scroller.click(_handleClickLink);
  }

  function _handleClickLink(e) {
    e.preventDefault();
    const id  = $(this).attr('href');
    const top = $(id).offset().top;
    $('.Header').removeClass('show-menu');
    $('.Header').removeClass('show-menu');
    $('body,html').animate({scrollTop: top}, 500);
  }

  return {
    init,
  };

}))(jQuery);

export default ScrollLink;



// WEBPACK FOOTER //
// ./src/static/js/modules/scroll-link.js